import config from 'config';
import { http_client } from './api';

const getList = async (page = null, perPage = null, sort = null, orderBy = null, search = null, cabangId = null, expenseType = null, month = null, year = null) => {
  return http_client
    .get(
      config.apiUrl +
        'operational-expense-input?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}` +
        `${cabangId ? '&cabang_id=' + cabangId : ''}` +
        `${expenseType ? '&expense_type=' + expenseType : ''}` +
        `${month ? '&month=' + month : ''}` +
        `${year ? '&year=' + year : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const getListArchive = async (page = null, perPage = null, sort = null, orderBy = null, search = null, cabangId = null, expenseType = null, startDate = null, endDate = null, createdBy = null) => {
  return http_client
    .get(
      config.apiUrl +
        'operational-expense-input/archive?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}` +
        `${cabangId ? '&cabang_id=' + cabangId : ''}` +
        `${expenseType ? '&expense_type=' + expenseType : ''}` +
        `${startDate ? '&start_date=' + startDate : ''}` +
        `${endDate ? '&end_date=' + endDate : ''}` +
        `${createdBy ? '&created_by=' + createdBy : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const create = async (data) => {
  return http_client.post(config.apiUrl + 'operational-expense-input', data).then((response) => {
    return response.data;
  });
};

const read = async (id) => {
  return http_client.get(config.apiUrl + 'operational-expense-input/' + id).then((response) => {
    return response.data;
  });
};

const update = async (id, data) => {
  return http_client.patch(config.apiUrl + 'operational-expense-input/' + id, data).then((response) => {
    return response.data;
  });
};

const del = async (id) => {
  return http_client.delete(config.apiUrl + 'operational-expense-input/' + id).then((response) => {
    return response.data;
  });
};

const changeStatus = async (id, status) => {
  return http_client.post(config.apiUrl + 'operational-expense-input/status/' + id, { status }).then((response) => {
    return response.data;
  });
};

const permanentDelete = async (id) => {
  return http_client.delete(config.apiUrl + 'operational-expense-input/permanent/' + id).then((response) => {
    return response.data;
  });
};

const InputPengeluaranService = {
  getList,
  getListArchive,
  create,
  read,
  update,
  del,
  changeStatus,
  permanentDelete
};

export default InputPengeluaranService;
